import { applyMiddleware, compose, createStore } from "redux";
import createSagaMiddleware from "redux-saga";
import { persistStore } from "redux-persist";
import { createReducers } from "./appReducers";
import { createSagas } from "./appSagas";
import logger from "redux-logger";

export const configureStore = (withLogs = false, whitelist = ["common", "surgery"]) => {
  const sagaMiddleware = createSagaMiddleware();
  let middlewares = [];
  if (withLogs && withLogs === true) middlewares.push(logger);
  // prettier-ignore
  const composeEnhancers = typeof window === "object" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : compose;
  const allReducers = createReducers(whitelist);
  const store = createStore(allReducers, composeEnhancers(applyMiddleware(...middlewares, sagaMiddleware)));
  const persistor = persistStore(store);
  const allSagas = createSagas();
  sagaMiddleware.run(allSagas);
  return { store, persistor };
};
